import { render, staticRenderFns } from "./list-order.vue?vue&type=template&id=79aef0f7&scoped=true"
import script from "./list-order.vue?vue&type=script&lang=js"
export * from "./list-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aef0f7",
  null
  
)

export default component.exports